import './driverSummary.css';
import {driversSummary, driverSummary} from "../../../data/driversData";

const DriversSummary = ({summary}) => {
    return (
        <ul className={'driver-summary flex align-top gap-40'}>
            <li className="distance">
                <div className={'number light-color sf-bold'}><span className={'green-color'}>30k</span>/28k</div>
                <div className="name sf-medium">Kms Travelled</div>
            </li>
            <li className="counts">
                <div className={'number light-color sf-bold'}><span className={'green-color'}>
                    {summary?.counts?.currentPeriod?.count}</span>/{summary?.counts?.lastPeriod?.count}
                </div>
                <div className="name sf-medium">Kms Travelled</div>
            </li>
            {
                summary?.alerts?.map((alert, index) =>
                    <li key={alert.id} className="alert">
                        <div className={`number sf-medium ${alert?.value > 10 ? 'red-color' : 'green-color'}`}>{alert?.value}</div>
                        <div className="name sf-medium">{alert['tooltip_name']}</div>
                    </li>
                )

            }

        </ul>
    )
}

export default DriversSummary;
